import { ContactInfo, KeycloakUserType, Role, UserInfo } from '@/core/types/shared'
import { Establishment } from './establishment.model'
import { SubscriptionType } from '@/utils/subscription/types'
import { Permission } from '@/core/api/policy'

export enum AccountType {
  Admin = 'Admin',
  ApiKey = 'ApiKey',
  NetsoinsPatient = 'NetsoinsPatient',
  Patient = 'Patient',
  Staff = 'Staff',
}

export type MedconnectAgentConfig = {
  enabledTools?: string[]
  disabledTools?: string[]
}

export type Account = {
  _id: string
  accountType: AccountType
  active: boolean
  contactInfo?: ContactInfo
  createdAt: string
  email: string
  establishment?: Omit<Establishment, 'admin'> & { admin?: string }
  groups?: string[]
  licenses: string[]
  permissions: Permission[]
  policies: string[]
  roles: Role[]
  subscription: SubscriptionType
  type: KeycloakUserType
  updatedAt: string
  userInfo: UserInfo
  medconnectAgentConfig?: MedconnectAgentConfig
}
